var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArchives(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "82.000000pt",
    height: "74.000000pt",
    viewBox: "0 0 82.000000 74.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,74.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 671 c-40 -65 -42 -71 -42 -150 0 -74 2 -81 20 -81 19 0 20 -7 20 -220 l0 -220 370 0 370 0 0 220 c0 213 1 220 20 220 18 0 20 7 20 81 0 79 -2 85 -42 150 l-43 69 -325 0 -325 0 -43 -69z m702 -6 c20 -30 36 -57 36 -60 0 -3 -166 -5 -370 -5 -203 0 -370 2 -370 5 0 3 16 30 36 60 l37 55 297 0 297 0 37 -55z m56 -145 l0 -60 -390 0 -390 0 0 60 0 60 390 0 390 0 0 -60z m-42 -287 l-3 -208 -345 0 -345 0 -3 208 -2 207 350 0 350 0 -2 -207z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 366 c-3 -8 -4 -25 -2 -38 3 -22 6 -23 108 -23 l105 0 0 35 0 35 -103 3 c-82 2 -103 0 -108 -12z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchives);
export default __webpack_public_path__ + "static/media/icon_archives.9b4cb17afa3de9f4613f71cd6db7f355.svg";
export { ForwardRef as ReactComponent };